<!-- 
	EmailVerificationComponent
	props: User
    role: User
	Called by @/views/User to display the enrollment/optin form to users who have not created their profile yet
-->

<template>
	<div class="email-verification text-white">
		<div v-if="user.data.emailVerified === true">
			<div
				v-if="user.apiData.IsVerified === true && user.apiData.Profile !== null"
			>
				<OptinForm v-bind:user="user" />
			</div>
			<div v-else-if="user.apiData.IsVerified === false">
				<div v-if="loading">
					<div class="pb-6">Please wait...</div>
					<Loading />
				</div>
				<div v-if="loading === false && success === true">
					You are being redirected...
				</div>
				<div v-if="loading === false && success === false">
					There was an error
				</div>
			</div>
		</div>
		<div v-else>
			<div>Your Email is not verified</div>
			<div v-if="!verificationSent && verificationCount === 0">
				<CustomButton @click="sendEmailVerification()"
					>Send Email Verification</CustomButton
				>
			</div>
			<div v-if="verificationSent">
				A Verification Email has been sent. Please check your junk mail.
			</div>
			<div v-if="!verificationSent && verificationCount !== 0">
				An error has occured. Please try again later.
			</div>
		</div>
	</div>
</template>

<script>
	import firebase from "firebase";

	import CustomButton from "@/components/CustomButton";
	import OptinForm from "@/components/OptinForm";
	import OptinFormTickets from "@/components/OptinFormTickets";
	import Loading from "@/components/Loading";

	import store from "../store";
	import { postVerifyEmail } from "@/utils/api";

	export default {
		name: "EmailVerificationComponent",
		components: {
			CustomButton,
			OptinForm,
			OptinFormTickets,
			Loading,
		},
		props: ["user"],
		data() {
			return {
				verificationSent: false,
				verificationCount: 0,
			};
		},
		setup(props) {
			// load user props and initiate loading
			let loading = true;
			let success = false;

			const uid = props.user.apiData.UserId;

			const data = {
				userId: uid,
				emailAddress: props.user.data.email,
				employeeId: props.user.additionalData.employeeId,
			};
			if (props.user.data.emailVerified === true) {
				// if email is verified by firebase pass data to api for verification
				const res = postVerifyEmail(uid, data).then((res) => {
					if (res.Success) {
						// if verified with api successfully cancel loading and trigger success
						success = true;
						loading = false;

						// refresh the user page and show form
						return (window.location.href = "/user");
					} else {
						// cancel loading and show verification failure
						success = false;
						loading = false;
					}
				});
			}

			return { loading, success };
		},
		methods: {
			async sendEmailVerification() {
				// DEPRECIATED
				// only allow a single verification email to be sent to user on action
				this.verificationCount += 1;

				try {
					await firebase.auth().currentUser.sendEmailVerification();

					this.verificationSent = true;
				} catch (err) {
					console.log(err);

					store.dispatch("setError", err);

					this.verificationSent = false;
				}
			},
		},
	};
</script>
